import * as React from "react";
import Radium from "radium";
import { withRouter, RouterState } from "found";
import { Button } from "@material-ui/core";

// components
import { LogoHorizontal } from "@components/logo";

// styles
import { colors } from "@clockwise/web-commons/src/styles/color.styles";

// constants
import { paths } from "@clockwise/client-commons/src/constants/site";

// internal
import {
  container,
  logo,
  logoContainer,
  gradientBar,
  content,
  promoButton,
} from "./HomeNav.styles";

// util
import { track, TrackingEvents } from "@util/analytics.util";
import { windowLocation } from "@util/location.util";

type IProps = RouterState;

const promoPaths = [paths.nonUserDefragSurvey];

const promoEvents = {
  [paths.nonUserDefragSurvey]: TrackingEvents.NON_USER_DEFRAG_SURVEY.CLICKED_TRY_CLOCKWISE,
};

// TODO (lsanwick) Replace this with TopNav component

@Radium
class HomeNavCmpt extends React.Component<IProps> {
  private onClickPromo(path: string) {
    const event = promoEvents[path];

    if (event) {
      track(event);
    }

    // TODO: https://app.asana.com/0/879916340247720/1157705287919017/f
    // give our track a bit of time to actually send, possibly flaky but it doesnt have a sync mechanism yet
    setTimeout(
      () => windowLocation.assign("HomeNavClickPromo", "https://www.getclockwise.com"),
      1500,
    );
  }

  public render() {
    const promoPath = promoPaths.find(
      (path) => this.props.match.location.pathname.indexOf(path) !== -1,
    );

    return (
      <div style={container}>
        <div style={gradientBar} />
        <div style={content}>
          <a style={logoContainer} href="/">
            <LogoHorizontal fill={colors.blueDusk.darker} style={logo} />
          </a>
          {promoPath ? (
            <div style={promoButton.container}>
              <Button
                onClick={() => this.onClickPromo(promoPath)}
                style={promoButton.button}
                color="primary"
                variant="contained"
              >
                Try Clockwise
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

///////////
// Redux //
///////////
export const HomeNav = withRouter<IProps>(HomeNavCmpt);
